import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

const DividerLineStyled = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${({ theme }) => theme.colors.gray300};
`;

const DividerLine = ({ className }) => (
  <DividerLineStyled className={className} />
);

DividerLine.propTypes = {
  className: PropTypes.string,
};

DividerLine.defaultProps = {
  className: null,
};

export default DividerLine;
